import { AppSubscription } from '@mondaydotcomorg/api-types';

export const featureBasedPricingPlans = {
  // old pricing plans
  '3seats': '3 Seats',
  gs15seats: '15 Seats',
  '30seats': '30 Seats',
  '60seats': '60 Seats',
  '120seats': '120 Seats',
  '240seats': '240 Seats',
  '400seats': '400 Seats',
  '600seats': '600 Seats',
  '1000seats': '1000 Seats',
  '1000plus': '1000+ Seats',

  // new pricing plans
  free: 'gs_free',
  starter: 'gs_starter_30',
  basic: 'gs_basic_55',
  standard: 'gs_standard_85',
  pro: 'gs_pro_115',
  enterprise: 'gs_enterprise_145',
  gs_enterprise_m: 'gs_enterprise_m',
  gs_enterprise_l: 'gs_enterprise_l',
  gs_enterprise_xl: 'gs_enterprise_xl',
  gs_enterprise_xxl: 'gs_enterprise_xxl',
};
const getPlanNameForOldPricing = (subscription: AppSubscription | null) => {
  if (!subscription) return 'Free';
  if (subscription?.is_trial) return 'Free Trial';
  return (
    featureBasedPricingPlans[
      subscription?.plan_id as keyof typeof featureBasedPricingPlans
    ] || 'Free'
  );
};

export const getPlanName = (
  subscription: AppSubscription | null,
  isOldPricing: boolean,
) => {
  if (isOldPricing) return getPlanNameForOldPricing(subscription);
  return planNames[subscription?.plan_id as keyof typeof planNames] || 'Free';
};

export const planNames = {
  [featureBasedPricingPlans.free]: 'Free',
  [featureBasedPricingPlans.starter]: 'Starter',
  [featureBasedPricingPlans.basic]: 'Basic',
  [featureBasedPricingPlans.standard]: 'Standard',
  [featureBasedPricingPlans.pro]: 'Pro',
  [featureBasedPricingPlans.enterprise]: 'Enterprise',
  [featureBasedPricingPlans.gs_enterprise_m]: 'Enterprise M',
  [featureBasedPricingPlans.gs_enterprise_l]: 'Enterprise L',
  [featureBasedPricingPlans.gs_enterprise_xl]: 'Enterprise XL',
  [featureBasedPricingPlans.gs_enterprise_xxl]: 'Enterprise XXL',
};

export const PLAN_LIMITS = {
  [featureBasedPricingPlans.free]: {
    send: { warning: 10, limit: 15 },
    generate: { warning: 15, limit: 20 },
  },
  [featureBasedPricingPlans.starter]: {
    send: { warning: 35, limit: 40 },
    generate: { warning: 245, limit: 250 },
  },
  [featureBasedPricingPlans.basic]: {
    send: { warning: 95, limit: 100 },
    generate: { warning: 495, limit: 500 },
  },
  [featureBasedPricingPlans.standard]: {
    send: { warning: 195, limit: 200 },
    generate: { warning: 995, limit: 1000 },
  },
  [featureBasedPricingPlans.pro]: {
    send: { warning: 395, limit: 400 },
    generate: { warning: 1495, limit: 1500 },
  },
  [featureBasedPricingPlans.enterprise]: {
    send: { warning: 895, limit: 900 },
    generate: { warning: 1995, limit: 2000 },
  },
  [featureBasedPricingPlans.gs_enterprise_m]: {
    send: { warning: 1395, limit: 1400 },
    generate: { warning: 2995, limit: 3000 },
  },
  [featureBasedPricingPlans.gs_enterprise_l]: {
    send: { warning: 1995, limit: 2000 },
    generate: { warning: 3995, limit: 4000 },
  },
  [featureBasedPricingPlans.gs_enterprise_xl]: {
    send: { warning: 2495, limit: 2500 },
    generate: { warning: 4995, limit: 5000 },
  },
  [featureBasedPricingPlans.gs_enterprise_xxl]: {
    send: { warning: 2995, limit: 3000 },
    generate: { warning: 5995, limit: 6000 },
  },
};
